import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { useGetInventory } from '../api/useGetInventory';
import { inventoryParamsAtom } from '../atoms/inventoryAtoms';
import { selectedInventoryIdsAtom } from '../atoms/inventorySelectionAtoms';

/**
 * Hook to get the actual selected inventory item IDs
 * Handles 'all' selection by getting IDs from the current page
 */
export const useSelectedInventoryIds = () => {
	const selectedInventory = useAtomValue(selectedInventoryIdsAtom);
	const params = useAtomValue(inventoryParamsAtom);
	const { data: inventoryResponse } = useGetInventory(params);

	const selectedIds = useMemo(() => {
		if (selectedInventory === 'all') {
			// When 'all' is selected, get IDs from current page items
			const items = inventoryResponse?.data || [];
			return new Set(items.map((item) => item.id));
		}
		return selectedInventory as Set<string>;
	}, [selectedInventory, inventoryResponse]);

	return selectedIds;
};
